import CookiesPolicy from './CookiesPolicy';

export default CookiesPolicy;
